import { render, staticRenderFns } from "./EditTruename.vue?vue&type=template&id=6d701f68&scoped=true"
import script from "./EditTruename.vue?vue&type=script&lang=js"
export * from "./EditTruename.vue?vue&type=script&lang=js"
import style0 from "./EditTruename.vue?vue&type=style&index=0&id=6d701f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d701f68",
  null
  
)

export default component.exports